import React from "react";
import { Carousel, Modal, Button } from "react-bootstrap";
import { useState } from "react";
import Album from "../images/album.png";
import Album2 from "../images/album2.png";
import Album3 from "../images/album3.png";

const Content = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <div className="content">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
        <path
          fill="#00000"
          fill-opacity="1"
          d="M0,64L24,85.3C48,107,96,149,144,154.7C192,160,240,128,288,106.7C336,85,384,75,432,69.3C480,64,528,64,576,74.7C624,85,672,107,720,144C768,181,816,235,864,256C912,277,960,267,1008,229.3C1056,192,1104,128,1152,112C1200,96,1248,128,1296,138.7C1344,149,1392,139,1416,133.3L1440,128L1440,320L1416,320C1392,320,1344,320,1296,320C1248,320,1200,320,1152,320C1104,320,1056,320,1008,320C960,320,912,320,864,320C816,320,768,320,720,320C672,320,624,320,576,320C528,320,480,320,432,320C384,320,336,320,288,320C240,320,192,320,144,320C96,320,48,320,24,320L0,320Z"
        ></path>
      </svg>
      <div className="carousel-card">
        <Carousel>
          <Carousel.Item interval={1000}>
            <img
              className="d-block w-100"
              src={Album}
              alt="First slide"
              onClick={handleShow}
            />
          </Carousel.Item>

          <Carousel.Item interval={1000}>
            <img
              className="d-block w-100"
              src={Album2}
              alt="Second slide"
              onClick={handleShow}
            />
          </Carousel.Item>

          <Carousel.Item interval={1000}>
            <img
              className="d-block w-100"
              src={Album3}
              alt="Third slide"
              onClick={handleShow}
            />
            <Modal
              show={show}
              onHide={handleClose}
              backdrop="static"
              keyboard={false}
              size="md"
              className="modal"
            >
              <Modal.Header closeButton>
                <Modal.Title>Twice Shop</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                This will redirect you to another page. Continue?
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  Close
                </Button>

                <Button
                  variant="primary"
                  as="a"
                  href="https://www.twiceshop.com"
                >
                  Yes
                </Button>
              </Modal.Footer>
            </Modal>
          </Carousel.Item>
        </Carousel>
      </div>

      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
        <path
          fill="#00000"
          fill-opacity="1"
          d="M0,64L24,85.3C48,107,96,149,144,154.7C192,160,240,128,288,106.7C336,85,384,75,432,69.3C480,64,528,64,576,74.7C624,85,672,107,720,144C768,181,816,235,864,256C912,277,960,267,1008,229.3C1056,192,1104,128,1152,112C1200,96,1248,128,1296,138.7C1344,149,1392,139,1416,133.3L1440,128L1440,0L1416,0C1392,0,1344,0,1296,0C1248,0,1200,0,1152,0C1104,0,1056,0,1008,0C960,0,912,0,864,0C816,0,768,0,720,0C672,0,624,0,576,0C528,0,480,0,432,0C384,0,336,0,288,0C240,0,192,0,144,0C96,0,48,0,24,0L0,0Z"
        ></path>
      </svg>
    </div>
  );
};

export default Content;
